import type { FunctionComponent } from "react";
import { CreatorListProposalsAdminPartial } from "../../../partials/admin/proposal/creator-list-proposals.admin.partials";

export const CreatorListProposalsAdminScreen: FunctionComponent = () => {
	return <CreatorListProposalsAdminPartial />;
};
